import type { I18nFn } from 'i18n/types/I18nFn';

export enum VolopFunction {
  ACCOUNTING_FINANCE = 'ACCOUNTING_FINANCE',
  ADMINISTRATIVE_OFFICE_SUPPORT = 'ADMINISTRATIVE_OFFICE_SUPPORT',
  ADVOCACY = 'ADVOCACY',
  ANIMAL_CARE = 'ANIMAL_CARE',
  ANIMAL_THERAPY = 'ANIMAL_THERAPY',
  ARCHIVING_DATA_ENTRY = 'ARCHIVING_DATA_ENTRY',
  ART_THERAPY = 'ART_THERAPY',
  ARTS_CRAFTS = 'ARTS_CRAFTS',
  BOARD_COMMITTEE = 'BOARD_COMMITTEE',
  BUSINESS_DEVELOPMENT = 'BUSINESS_DEVELOPMENT',
  CASE_SOCIAL_WORK = 'CASE_SOCIAL_WORK',
  CHILD_CARE = 'CHILD_CARE',
  CHILD_DEVELOPMENT = 'CHILD_DEVELOPMENT',
  CHILD_WELFARE = 'CHILD_WELFARE',
  CITIZENSHIP = 'CITIZENSHIP',
  COMMUNICATIONS = 'COMMUNICATIONS',
  COMMUNITY_BELONGING = 'COMMUNITY_BELONGING',
  COMMUNITY_ENGAGEMENT_OUTREACH = 'COMMUNITY_ENGAGEMENT_OUTREACH',
  COMMUNITY_ORGANIZING = 'COMMUNITY_ORGANIZING',
  CONFLICT_RESOLUTION = 'CONFLICT_RESOLUTION',
  CONSERVATION = 'CONSERVATION',
  CONSTRUCTION_HOME_REPAIR = 'CONSTRUCTION_HOME_REPAIR',
  COUNSELING = 'COUNSELING',
  CORPORATE_PHILANTHROPY = 'CORPORATE_PHILANTHROPY',
  CORPORATE_RESPONSIBILITY = 'CORPORATE_RESPONSIBILITY',
  CRISIS_INTERVENTION = 'CRISIS_INTERVENTION',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  DANCE = 'DANCE',
  DATA_ANALYSIS = 'DATA_ANALYSIS',
  DATA_ENTRY = 'DATA_ENTRY',
  DATABASE_ADMINISTRATION = 'DATABASE_ADMINISTRATION',
  DESIGN = 'DESIGN',
  DIRECT_SERVICES = 'DIRECT_SERVICES',
  DISASTER_RELIEF = 'DISASTER_RELIEF',
  DIVERSITY_EQUITY_INCLUSION = 'DIVERSITY_EQUITY_INCLUSION',
  DONATION_DRIVE = 'DONATION_DRIVE',
  EDUCATION = 'EDUCATION',
  ELDER_CARE = 'ELDER_CARE',
  EMPLOYEE_ENGAGEMENT = 'EMPLOYEE_ENGAGEMENT',
  EQUIPMENT_FACILITIES = 'EQUIPMENT_FACILITIES',
  ESL = 'ESL',
  EVENT_SUPPORT = 'EVENT_SUPPORT',
  FARMING = 'FARMING',
  FOOD_DELIVERY_DISTRIBUTION = 'FOOD_DELIVERY_DISTRIBUTION',
  FOOD_SERVICE = 'FOOD_SERVICE',
  FUNDRAISING = 'FUNDRAISING',
  GARDENING = 'GARDENING',
  GRANTS_ADMINISTRATION = 'GRANTS_ADMINISTRATION',
  GRAPHIC_DESIGN = 'GRAPHIC_DESIGN',
  HABITAT_RESTORATION = 'HABITAT_RESTORATION',
  HEALTH_WELLNESS = 'HEALTH_WELLNESS',
  HEALTHCARE_PROVIDER_PRACTITIONER = 'HEALTHCARE_PROVIDER_PRACTITIONER',
  HOSPICE_CARE = 'HOSPICE_CARE',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  INVESTIGATIONS = 'INVESTIGATIONS',
  LANGUAGES = 'LANGUAGES',
  LEADERSHIP = 'LEADERSHIP',
  LEGAL = 'LEGAL',
  LOBBYING = 'LOBBYING',
  MARKETING = 'MARKETING',
  MASSAGE_THERAPY = 'MASSAGE_THERAPY',
  MENTOR_TUTOR = 'MENTOR_TUTOR',
  MUSIC = 'MUSIC',
  MUSIC_THERAPY = 'MUSIC_THERAPY',
  NETWORKING = 'NETWORKING',
  NURSING = 'NURSING',
  OPERATIONS = 'OPERATIONS',
  PARTNERSHIPS = 'PARTNERSHIPS',
  PATIENT_CARE = 'PATIENT_CARE',
  PEOPLE_SKILLS = 'PEOPLE_SKILLS',
  PHOTOGRAPHY = 'PHOTOGRAPHY',
  PHYSICAL_SERVICE = 'PHYSICAL_SERVICE',
  PROBLEM_SOLVING = 'PROBLEM_SOLVING',
  PROGRAM_MANAGEMENT = 'PROGRAM_MANAGEMENT',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
  PROJECT_RESEARCH_STUDY = 'PROJECT_RESEARCH_STUDY',
  PUBLIC_HEALTH = 'PUBLIC_HEALTH',
  PUBLIC_RELATIONS = 'PUBLIC_RELATIONS',
  PUBLIC_SPEAKING = 'PUBLIC_SPEAKING',
  READING_WRITING = 'READING_WRITING',
  RELATIONSHIP_BUILDING = 'RELATIONSHIP_BUILDING',
  RESEARCH = 'RESEARCH',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  SPORTS_FITNESS_COACHING = 'SPORTS_FITNESS_COACHING',
  STEM = 'STEM',
  STRATEGIC_PLANNING = 'STRATEGIC_PLANNING',
  SUSTAINABILITY = 'SUSTAINABILITY',
  TEACHING_AND_INSTRUCTION = 'TEACHING_AND_INSTRUCTION',
  TECHNOLOGY_IT = 'TECHNOLOGY_IT',
  TECHNOLOGY_SUPPORT_WEB_DESIGN = 'TECHNOLOGY_SUPPORT_WEB_DESIGN',
  THEATER = 'THEATER',
  VETERAN_CARE = 'VETERAN_CARE',
  VIDEOGRAPHY = 'VIDEOGRAPHY',
  VISUAL_ARTS = 'VISUAL_ARTS',
  VOLUNTEER_COORDINATION = 'VOLUNTEER_COORDINATION',
  WRITING_EDITORIAL = 'WRITING_EDITORIAL',
  WRITING_JOURNALISM = 'WRITING_JOURNALISM',
  YOUTH_SERVICES = 'YOUTH_SERVICES',
}

export function VOLOP_FUNCTIONS(i18n: I18nFn) {
  return {
    [VolopFunction.ACCOUNTING_FINANCE]: i18n('Accounting & Finance'),
    [VolopFunction.ADMINISTRATIVE_OFFICE_SUPPORT]: i18n('Administrative'),
    [VolopFunction.ADVOCACY]: i18n('Advocacy'),
    [VolopFunction.ANIMAL_CARE]: i18n('Animal Care'),
    [VolopFunction.ANIMAL_THERAPY]: i18n('Animal Therapy'),
    [VolopFunction.ARCHIVING_DATA_ENTRY]: i18n('Archiving/Data Entry'),
    [VolopFunction.ART_THERAPY]: i18n('Art Therapy'),
    [VolopFunction.ARTS_CRAFTS]: i18n('Arts & Crafts'),
    [VolopFunction.BOARD_COMMITTEE]: i18n('Board/Committee'),
    [VolopFunction.BUSINESS_DEVELOPMENT]: i18n('Business Development'),
    [VolopFunction.CASE_SOCIAL_WORK]: i18n('Case / Social Work'),
    [VolopFunction.CHILD_CARE]: i18n('Child Care'),
    [VolopFunction.CHILD_DEVELOPMENT]: i18n('Child Development'),
    [VolopFunction.CHILD_WELFARE]: i18n('Child Welfare'),
    [VolopFunction.CITIZENSHIP]: i18n('Citizenship'),
    [VolopFunction.COMMUNICATIONS]: i18n('Communications'),
    [VolopFunction.COMMUNITY_BELONGING]: i18n('Community Belonging'),
    [VolopFunction.COMMUNITY_ENGAGEMENT_OUTREACH]: i18n(
      'Community Engagement / Outreach',
    ),
    [VolopFunction.COMMUNITY_ORGANIZING]: i18n('Community Organizing'),
    [VolopFunction.CONFLICT_RESOLUTION]: i18n('Conflict Resolution'),
    [VolopFunction.CONSERVATION]: i18n('Conservation'),
    [VolopFunction.CONSTRUCTION_HOME_REPAIR]: i18n(
      'Construction / Home Repair',
    ),
    [VolopFunction.COUNSELING]: i18n('Counseling'),
    [VolopFunction.CORPORATE_PHILANTHROPY]: i18n('Corporate Philanthropy'),
    [VolopFunction.CORPORATE_RESPONSIBILITY]: i18n('Corporate Responsibility'),
    [VolopFunction.CRISIS_INTERVENTION]: i18n('Crisis Intervention'),
    [VolopFunction.CUSTOMER_SERVICE]: i18n('Customer Service'),
    [VolopFunction.DANCE]: i18n('Dance'),
    [VolopFunction.DATA_ANALYSIS]: i18n('Data Analysis'),
    [VolopFunction.DATA_ENTRY]: i18n('Data Entry'),
    [VolopFunction.DATABASE_ADMINISTRATION]: i18n('Database Administration'),
    [VolopFunction.DESIGN]: i18n('Design'),
    [VolopFunction.DIRECT_SERVICES]: i18n('Direct Services'),
    [VolopFunction.DISASTER_RELIEF]: i18n('Disaster Relief'),
    [VolopFunction.DIVERSITY_EQUITY_INCLUSION]: i18n(
      'Diversity, Equity & Inclusion',
    ),
    [VolopFunction.DONATION_DRIVE]: i18n('Donation Drive'),
    [VolopFunction.EDUCATION]: i18n('Education'),
    [VolopFunction.ELDER_CARE]: i18n('Elder Care'),
    [VolopFunction.EMPLOYEE_ENGAGEMENT]: i18n('Employee Engagement'),
    [VolopFunction.EQUIPMENT_FACILITIES]: i18n('Equipment Facilities'),
    [VolopFunction.ESL]: i18n('English as Second Language (ESL)'),
    [VolopFunction.EVENT_SUPPORT]: i18n('Event Support / Management'),
    [VolopFunction.FARMING]: i18n('Farming'),
    [VolopFunction.FOOD_DELIVERY_DISTRIBUTION]: i18n(
      'Food Delivery / Distribution',
    ),
    [VolopFunction.FOOD_SERVICE]: i18n('Food / Beverage Service'),
    [VolopFunction.FUNDRAISING]: i18n('Development / Fundraising'),
    [VolopFunction.GARDENING]: i18n('Gardening'),
    [VolopFunction.GRANTS_ADMINISTRATION]: i18n('Grants Administration'),
    [VolopFunction.GRAPHIC_DESIGN]: i18n('Graphic Design'),
    [VolopFunction.HABITAT_RESTORATION]: i18n('Habitat Restoration'),
    [VolopFunction.HEALTH_WELLNESS]: i18n('Health & Wellness'),
    [VolopFunction.HEALTHCARE_PROVIDER_PRACTITIONER]: i18n(
      'Health Provider / Practitioner',
    ),
    [VolopFunction.HOSPICE_CARE]: i18n('Hospice Care'),
    [VolopFunction.HUMAN_RESOURCES]: i18n('Human Resources'),
    [VolopFunction.INVESTIGATIONS]: i18n('Investigations'),
    [VolopFunction.LANGUAGES]: i18n('Languages'),
    [VolopFunction.LEADERSHIP]: i18n('Leadership'),
    [VolopFunction.LEGAL]: i18n('Legal'),
    [VolopFunction.LOBBYING]: i18n('Lobbying'),
    [VolopFunction.MARKETING]: i18n('Marketing'),
    [VolopFunction.MASSAGE_THERAPY]: i18n('Massage Therapy'),
    [VolopFunction.MENTOR_TUTOR]: i18n('Mentor/Tutor'),
    [VolopFunction.MUSIC]: i18n('Music'),
    [VolopFunction.MUSIC_THERAPY]: i18n('Music Therapy'),
    [VolopFunction.NETWORKING]: i18n('Networking'),
    [VolopFunction.NURSING]: i18n('Nursing'),
    [VolopFunction.OPERATIONS]: i18n('Operations'),
    [VolopFunction.PARTNERSHIPS]: i18n('Partnerships'),
    [VolopFunction.PATIENT_CARE]: i18n('Patient Care'),
    [VolopFunction.PEOPLE_SKILLS]: i18n('People Skills'),
    [VolopFunction.PHOTOGRAPHY]: i18n('Photography'),
    [VolopFunction.PHYSICAL_SERVICE]: i18n(
      'Physical Service (Painting, Farming, etc.)',
    ),
    [VolopFunction.PROBLEM_SOLVING]: i18n('Problem Solving'),
    [VolopFunction.PROGRAM_MANAGEMENT]: i18n('Program Management'),
    [VolopFunction.PROJECT_MANAGEMENT]: i18n('Project Management'),
    [VolopFunction.PROJECT_RESEARCH_STUDY]: i18n('Project or Research Study'),
    [VolopFunction.PUBLIC_HEALTH]: i18n('Public Health'),
    [VolopFunction.PUBLIC_RELATIONS]: i18n('Public Relations'),
    [VolopFunction.PUBLIC_SPEAKING]: i18n('Public Speaking'),
    [VolopFunction.READING_WRITING]: i18n('Reading / Writing'),
    [VolopFunction.RELATIONSHIP_BUILDING]: i18n('Relationship Building'),
    [VolopFunction.RESEARCH]: i18n('Research'),
    [VolopFunction.SOCIAL_MEDIA]: i18n('Social Media'),
    [VolopFunction.SPORTS_FITNESS_COACHING]: i18n('Sports & Fitness/Coaching'),
    [VolopFunction.STEM]: i18n('STEM'),
    [VolopFunction.STRATEGIC_PLANNING]: i18n('Strategic Planning'),
    [VolopFunction.SUSTAINABILITY]: i18n('Sustainability'),
    [VolopFunction.TEACHING_AND_INSTRUCTION]: i18n('Teaching & Instruction'),
    [VolopFunction.THEATER]: i18n('Theater'),
    [VolopFunction.VETERAN_CARE]: i18n('Veteran Care'),
    [VolopFunction.VIDEOGRAPHY]: i18n('Videography'),
    [VolopFunction.VISUAL_ARTS]: i18n('Visual Arts'),
    [VolopFunction.VOLUNTEER_COORDINATION]: i18n('Volunteer Coordination'),
    [VolopFunction.TECHNOLOGY_IT]: i18n('Technology / IT'),
    [VolopFunction.TECHNOLOGY_SUPPORT_WEB_DESIGN]: i18n('Web Design'),
    [VolopFunction.WRITING_EDITORIAL]: i18n('Writing Editorial'),
    [VolopFunction.WRITING_JOURNALISM]: i18n('Writing Journalism'),
    [VolopFunction.YOUTH_SERVICES]: i18n('Youth Services'),
  } satisfies Record<VolopFunction, string>;
}

export function VOLOP_FUNCTION_CHECKBOX_OPTIONS(i18n: I18nFn) {
  return Object.entries(VOLOP_FUNCTIONS(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key,
      label: value,
    }));
}

export function VOLOP_FUNCTION_RADIO_OR_SELECT_OPTIONS(i18n: I18nFn) {
  return Object.entries(VOLOP_FUNCTIONS(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key,
      label: value,
    }));
}
